import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGraduateCap = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 8.04491L10.6766 3.31663C11.54 2.89446 12.5495 2.89446 13.4129 3.31663L21.993 7.50977C23.3357 8.16502 23.3357 10.0785 21.993 10.7337L13.4129 14.9268C12.5495 15.349 11.54 15.349 10.6766 14.9268L6.67014 12.9694C6.21705 12.7482 5.68904 13.0776 5.68904 13.5819V17.9557C5.68904 19.0997 6.35976 20.1653 7.42409 20.5827C10.4614 21.7743 13.4867 21.7897 16.4989 20.5911C17.5561 20.1713 18.2197 19.1093 18.2197 17.9713V12.5901M1.55143 17.7368V12.753C1.55143 11.6815 2.33155 10.7693 3.39113 10.6028L7.97672 9.88454",
		stroke: "#888EAA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGraduateCap;
